<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
export default {
  components: { ErrorMessage, Layout, PageHeader,ModelSelect },
  data() {
    return {
      title: "Flight Search Log",
      items: [
        {
          text: "Flight Search Log",
          href: "/",
        },
        {
          text: "List",
          active: true,
        },
      ],
      admins: [],
        alladmins:[],
        display_div:true,
        totalItems:"",
        lastPage:"",
        firstPage:"",
        currentPage:"",
        toNext:"",
        perPage:"",
        pageSequence:"",
        fromIndex:"",
      pin: "",
      flightSearchLogs: [],
      flightSearchLog: [],
        bookingRequest:"",
        bookingResponse:"",
        cancelRequest:"",
        cancelResponse:"",
        ticketRequest:"",
        ticketResponse:"",
        booking:false,
        cancel:false,
        ticket:false,
        user_type:"",
      user_id: "",
        request:"",
      errors: null,
        visible:false,
        message:"",
        search_startdate:"",
        search_enddate:"",
        search_origin:"",
        search_destination:"",
        search_class:"",
        search_trip_type:"",
        search_currency:"",
        search_departure_date:"",
        search_adult_no:"",
        search_children_no:"",
        search_infant_no:"",
        search_search_date:"",
    };
  },
  mounted() {
    this.getAdminList();
    this.search();
  },
  computed: {
        filteredList() {
            return this.flightSearchLogs.filter(flightSearchLog => {
                return flightSearchLog.origin.toLowerCase().includes(this.search_origin.toLowerCase())
                    && flightSearchLog.destination.toLowerCase().includes(this.search_destination.toLowerCase())
                    && flightSearchLog.class_type.toLowerCase().includes(this.search_class.toLowerCase())
                    && flightSearchLog.trip_type.toLowerCase().includes(this.search_trip_type.toLowerCase())
                    && flightSearchLog.currency.toLowerCase().includes(this.search_currency.toLowerCase())
                    // && flightSearchLog.departure_date.toLowerCase().includes(this.search_departure_date.toLowerCase())
                    && flightSearchLog.no_of_adult.toString().includes(this.search_adult_no.toString())
                    && flightSearchLog.no_of_child.toString().includes(this.search_children_no.toString())
                    && flightSearchLog.no_of_infant.toString().includes(this.search_infant_no.toString())
                    && flightSearchLog.created_at.includes(this.search_search_date)
            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      toggleDiv: function() {
          this.display_div = !this.display_div;
      },
      async getBookingDetails(flightSearchLog){
          var format = require('xml-formatter');
          this.bookingRequest=this.isJson(flightSearchLog.flight_booking_action_logs.booking_request_xml) ? JSON.stringify(JSON.parse(flightSearchLog.flight_booking_action_logs.booking_request_xml),null,4) : format(flightSearchLog.flight_booking_action_logs.booking_request_xml);
          this.bookingResponse=this.isJson(flightSearchLog.flight_booking_action_logs.booking_response_xml) ? JSON.stringify(JSON.parse(flightSearchLog.flight_booking_action_logs.booking_response_xml),null,4) : format(flightSearchLog.flight_booking_action_logs.booking_response_xml);
          this.cancelRequest=this.isJson(flightSearchLog.flight_booking_action_logs.cancel_request_xml) ? JSON.stringify(JSON.parse(flightSearchLog.flight_booking_action_logs.cancel_request_xml),null,4) : format(flightSearchLog.flight_booking_action_logs.cancel_request_xml);
          this.cancelResponse=this.isJson(flightSearchLog.flight_booking_action_logs.cancel_response_xml) ? JSON.stringify(JSON.parse(flightSearchLog.flight_booking_action_logs.cancel_response_xml),null,4) : format(flightSearchLog.flight_booking_action_logs.cancel_response_xml);
          this.ticketRequest=this.isJson(flightSearchLog.flight_booking_action_logs.ticket_request_xml) ? JSON.stringify(JSON.parse(flightSearchLog.flight_booking_action_logs.ticket_request_xml),null,4) : format(flightSearchLog.flight_booking_action_logs.ticket_request_xml);
          this.ticketResponse=this.isJson(flightSearchLog.flight_booking_action_logs.ticket_response_xml) ? JSON.stringify(JSON.parse(flightSearchLog.flight_booking_action_logs.ticket_response_xml),null,4) : format(flightSearchLog.flight_booking_action_logs.ticket_response_xml);
      },
      isJson(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
},
      async getAdminList() {
          try {
              axios
                  .get("/api/user/approved/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                              if(temp[i].account_type=='b2c'){
                                  if(temp[i].first_name==null){
                                      temp[i].text=temp[i].email + '(unregistered)';
                                  }else{
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  }
                                  temp[i].value = temp[i].id;
                                  arr.push(temp[i]);
                              }

                          }
                          this.alladmins=arr;
                          this.admins = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async clear() {
          this.user_type="";
          this.user_id="";
          this.search_startdate="";
          this.search_enddate="";
          this.admins=this.alladmins;
      },
    async search(page=1) {
      try {
        axios
          .get("/api/flight-search-log/list", {
            params: {
                accessToken: localStorage.getItem("access_tocken"),
                page:page,
                user_type: this.user_type,
                user_id: this.user_id,
                search_startdate:this.search_startdate,
                search_enddate:this.search_enddate,
            },
          })
          .then((response) => {
            if (response.data.status) {
                console.log(response);
                this.flightSearchLogs=response.data.data.data;
                this.request=response.data.data;
                this.totalItems=response.data.data.total;
                this.lastPage=response.data.data.last_page
                this.currentPage=response.data.data.current_page;
                this.toNext=response.data.data.to;
                this.perPage=response.data.data.per_page;
                this.fromIndex=response.data.data.from;
                let pages=Math.ceil(response.data.data.total/this.perPage);
                if(pages>=5){
                    this.pageSequence=Math.ceil(pages/3);
                }
                else{
                    this.pageSequence=this.lastPage;
                }
                if(this.pageSequence>=15){
                    this.pageSequence=Math.ceil(pages/6);
                }
                this.firstPage=0;
               if(this.currentPage>=this.pageSequence && pages>=5){

                   this.firstPage=Math.ceil(this.currentPage-(this.pageSequence/2));
                   this.pageSequence=Math.ceil(this.currentPage+(this.pageSequence/2));
                   if(this.pageSequence>=this.lastPage){
                       this.pageSequence=this.lastPage;
                       //this.firstPage=this.pageSequence-this.currentPage;
                   }
               }

            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      onChange(event) {
          this.user_type=event.target.value;
          var temp=this.alladmins;
          var arr=[];
          var i;
          for (i=0;i<temp.length;i++){
              if (temp[i].account_type==event.target.value){
                  arr.push(temp[i]);
              }
          }
          this.admins = arr;
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
              <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
              <h4 class="card-title">Flight Search Log List</h4>
            <div v-if="display_div" class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="user_type">Select User Type</label>
                        <select
                            id="user_type"
                            name="user_type"
                            v-model="user_type"
                            @change="onChange($event)"
                            class="form-control"
                            placeholder="Select User Type">
                            <option value="null">Unregistered
                            </option>
                            <option value="b2b">B2B
                            </option>
                            <option value="b2c">B2C
                            </option>
                        </select>
                    </div>
                </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Select User</label>
                    <model-select :options="admins"
                                  v-model="user_id"
                                  placeholder="Select User">
                    </model-select>
                </div>
              </div>
                <div class="col-md-4">
                    <div>
                        <label for="start-datepicker">Search Date From</label>
                        <b-form-datepicker id="start-datepicker1" v-model="search_startdate" class="mb-2"></b-form-datepicker>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <label for="end-datepicker">Search Date To</label>
                        <b-form-datepicker id="end-datepicker" v-model="search_enddate" class="mb-2"></b-form-datepicker>
                    </div>
                </div>
              <div class="col-md-12 text-center"><span><button class="btn btn-primary" @click.prevent="search()">Search</button></span><span><button class="btn btn-light" @click.prevent="clear()">Clear</button></span></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-modal
                  id="modal-lg1"
                  size="lg"
                  title="Details"
                  title-class="font-18"
                  hide-footer
              >
                  <div class="padding-5px">
                      <div>
                          <h4 >Booking Request</h4>
                    <div>
                                        <textarea rows="30" cols="65">
                                            {{bookingRequest}}
                                        </textarea>
                        <h4 >Booking Response</h4>
                        <textarea rows="30" cols="65">
                                            {{bookingResponse}}
                                        </textarea>


                    </div>
                      </div>
                  </div>

              </b-modal>
              <b-modal
                  id="modal-lg2"
                  size="lg"
                  title="Details"
                  title-class="font-18"
                  hide-footer
              >
                  <div class="padding-5px">
                      <div>
                          <h4 >Booking Cancel Request</h4>
                          <div>
                                        <textarea rows="30" cols="65">
                                            {{cancelRequest}}
                                        </textarea>
                              <h4 >Booking Cancel Response</h4>
                              <textarea rows="30" cols="65">
                                            {{cancelResponse}}
                                        </textarea>


                          </div>
                      </div>
                  </div>

              </b-modal>
              <b-modal
                  id="modal-lg3"
                  size="lg"
                  title="Details"
                  title-class="font-18"
                  hide-footer
              >
                  <div class="padding-5px">
                      <div>
                          <h4 >Ticket Request</h4>

                          <div>
                                        <textarea rows="30" cols="65">
                                            {{ticketRequest}}
                                        </textarea>
                              <h4 >Ticket Response</h4>
                              <textarea rows="30" cols="65">
                                            {{ticketResponse}}
                                        </textarea>


                          </div>
                      </div>
                  </div>

              </b-modal>
<!--            <h4 class="card-title">Booking List</h4>-->
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
<!--                      <th>User Type</th>-->
<!--                      <th>First Name</th>-->
<!--                      <th>Last Name</th>-->
                      <th>User Name <br> User Email</th>
                      <th>Search Ref Key</th>
                      <th>Search D.T</th>
                      <th>Route</th>
                      <th>Dep. Date</th>
                      <th>Class <br>Trip Type</th>
                      <th>Pax</th>
                      <th>Log</th>
<!--                    <th>Origin</th>-->
<!--                    <th>Destination</th>-->
<!--                    <th>Class</th>-->

<!--                      <th>Currency</th>-->

<!--                      <th>No of Adults</th>-->
<!--                    <th>No of Children</th>-->
<!--                      <th>No of Infant</th>-->

                  </tr>
<!--                  <tr>-->
<!--                    <td> &nbsp </td>-->
<!--                      <td> &nbsp </td>-->
<!--                      <td> &nbsp </td>-->
<!--                      <td> &nbsp </td>-->
<!--                      <td> &nbsp </td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_origin" placeholder="Search" /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_destination" placeholder="Search " /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_class" placeholder="Search " /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_trip_type" placeholder="Search " /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_currency" placeholder="Search " /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_departure_date" placeholder="Search " /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_adult_no" placeholder="Search " /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_children_no" placeholder="Search " /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_infant_no" placeholder="Search " /></td>-->
<!--                    <td><input type="text" class="app-search form-control" v-model="search_search_date" placeholder="Search " /></td>-->

<!--                  </tr>-->
                </thead>
                <tbody>
                  <tr v-for="(flightSearchLog,index) in flightSearchLogs"  v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td v-if="flightSearchLog.user!=null">{{flightSearchLog.user.username==null?'N/A':flightSearchLog.user.username}} <br>{{flightSearchLog.user.email==null?'N/A':flightSearchLog.user.email}}</td>
                      <td v-else>Unregistered user</td>
                      <td >{{flightSearchLog.flight_booking_action_logs==null ? 'N/A' :flightSearchLog.flight_booking_action_logs.search_reference_key}}</td>
                      <td>{{flightSearchLog.created_at | moment('LLL')}}</td>
                    <td>{{flightSearchLog.origin}}-{{flightSearchLog.destination}}</td>
                      <td>{{flightSearchLog.departure_date | moment('LLL')}}</td>
                    <td>{{flightSearchLog.class_type.substring(0,3)}}-{{flightSearchLog.trip_type}}</td>
                      <td>{{flightSearchLog.no_of_adult+flightSearchLog.no_of_child+flightSearchLog.no_of_infant}}</td>
<!--                      <td v-if="flightSearchLog.flight_booking_action_logs!=null">{{parseXml(flightSearchLog.flight_booking_action_logs.ticket_response_xml)}}</td>-->
                      <td>
                          <div v-if="flightSearchLog.flight_booking_action_logs!=null"><b-button size="sm" v-b-modal.modal-lg1 variant="primary" v-if="flightSearchLog.flight_booking_action_logs.booking_request_xml!=null" @click.prevent="getBookingDetails(flightSearchLog)" >Booking</b-button></div><br>
                          <div v-if="flightSearchLog.flight_booking_action_logs!=null"><b-button size="sm" v-b-modal.modal-lg2 variant="primary" v-if="flightSearchLog.flight_booking_action_logs.cancel_request_xml!=null" @click.prevent="getBookingDetails(flightSearchLog)" >Cancel</b-button></div><br>
                          <div v-if="flightSearchLog.flight_booking_action_logs!=null"><b-button size="sm" v-b-modal.modal-lg3 variant="primary" v-if="flightSearchLog.flight_booking_action_logs.ticket_request_xml!=null" @click.prevent="getBookingDetails(flightSearchLog)" >Ticketing</b-button></div>
                      </td>
                  </tr>
                </tbody>
              </table>
                <ul class="pagination pagination-rounded justify-content-end mb-2">
                    <li :class="['page-item',currentPage < 2 ? 'disabled' : '']">
                        <a class="page-link" v-on:click.prevent="search(page=currentPage-1)" aria-label="Previous">
                            <i class="mdi mdi-chevron-left"></i>
                        </a>
                    </li>
                    <li :class="['page-item',currentPage==index ? 'active' : '']" v-for="index in pageSequence" v-if="index>firstPage">
                        <a class="page-link" v-on:click.prevent="search(page=index)">{{index}}</a>
                    </li>
                    <li :class="['page-item',toNext == totalItems ? 'disabled' : '']">
                        <a class="page-link" v-on:click.prevent="search(page=currentPage+1)" aria-label="Next">
                            <i class="mdi mdi-chevron-right"></i>
                        </a>
                    </li>
                </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.page-item{
    cursor: pointer;
}
</style>
